<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Plan de Capacitación - Listado (EI 088)</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Año" dense v-model="filtroperiodo">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-btn tile color="success" @click="cargarListados()">
                                <v-icon left> mdi-magnify </v-icon>
                                Buscar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="200" :footer-props="{
                    itemsPerPageText: 'planillas por página',
                }">
                <!-- <template v-slot:top>
                    <v-toolbar flat dense>
                        <v-toolbar-title>
                            <font color="green">Personal con ingreso anterior al 01/06/{{ periodoanterior }}</font>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template> -->
                <template v-slot:item.estado="{ item }">
                    <v-chip :color="getColor(item.estado)">
                        {{ item.estado }}
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="verPlanilla(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>ver plan</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="purple" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="editarPlanilla(item)">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>editar plan</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <VerPlanilla :visible="showPlanilla" :legajo="editedItem.legajo" :nombre="editedItem.nombre"
                :periodo="this.filtroperiodo" @close="showPlanilla = false"></VerPlanilla>
            <EditarPlan :visible="showEditar" :legajo="editedItem.legajo" :nombre="editedItem.nombre"
                :periodo="this.filtroperiodo" @close="showEditar = false">
            </EditarPlan>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import VerPlanilla from "../Capacitaciones/Informe.vue";
import EditarPlan from "../Capacitaciones/Editarplan.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    components: { VerPlanilla, EditarPlan },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroestado: "Todos",
        filtroperiodo: moment().format("YYYY"),
        filtrogerencia: "Todos",
        listado: [],
        listadoO: [],
        periodoanterior: "",
        showPlanilla: false,
        showEditar: false,
        headers: [
            {
                text: "Legajo",
                align: "center",
                sortable: false,
                value: "legajo",
            },
            { text: "Nombre", value: "nombre", sortable: false },
            { text: "Estado", value: "estado", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],
    }),
    computed: {
        show: {
            get() {

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        getColor(estado) {
            if (estado == "Cargado")
                return "green";
            if (estado == "Sin Cargar" || estado == "" || estado == null)
                return "red";
        },

        cargarListados() {
            this.vaciarModels();

            const periodo = this.filtroperiodo;
            this.periodoanterior = parseInt(this.filtroperiodo) - 1;
            let self = this;

            axios
                .get("/RRHH/ListadoPlan?", {
                    params: {
                        filtroperiodo: periodo,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    console.log("listado", self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
        verPlanilla(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showPlanilla = true;
        },
        editarPlanilla(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>